export default {"src":"/_next/static/media/empty-cart.c70d299b.svg","height":80,"width":80};